import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';

// Pages
import Admin from './pages/Admin';
import BadHabits from './pages/BadHabits';
import Charts from './pages/Charts';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Settings from './pages/Settings';
import Weight from './pages/Weight';
import Workouts from './pages/Workouts';

import Layout from './components/layout/Layout';

const PrivateRoute = ({ children }) => {
    const { user, loading } = useAuth();

    if (loading) {
        return <div style={{ padding: '2rem', textAlign: 'center' }}>Загрузка...</div>;
    }

    return user ? children : <Navigate to="/login" />;
};

function AppRoutes() {
    const { user } = useAuth();

    return (
        <Routes>
            <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />

            <Route path="/" element={
                <PrivateRoute>
                    <Layout><Dashboard /></Layout>
                </PrivateRoute>
            } />

            <Route path="/weight" element={
                <PrivateRoute>
                    <Layout><Weight /></Layout>
                </PrivateRoute>
            } />

            <Route path="/workouts" element={
                <PrivateRoute>
                    <Layout><Workouts /></Layout>
                </PrivateRoute>
            } />

            <Route path="/bad-habits" element={
                <PrivateRoute>
                    <Layout><BadHabits /></Layout>
                </PrivateRoute>
            } />

            <Route path="/charts" element={
                <PrivateRoute>
                    <Layout><Charts /></Layout>
                </PrivateRoute>
            } />

            <Route path="/settings" element={
                <PrivateRoute>
                    <Layout><Settings /></Layout>
                </PrivateRoute>
            } />

            <Route path="/admin" element={
                <PrivateRoute>
                    <Layout><Admin /></Layout>
                </PrivateRoute>
            } />
        </Routes>
    );
}

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <AppRoutes />
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
